import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Wrench, Settings, Droplets, Building2, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../mockData';

const Services = () => {
  const iconMap = {
    Wrench: Wrench,
    Settings: Settings,
    Droplets: Droplets,
    Building2: Building2
  };

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Hizmetlerimiz</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Profesyonel ekibimizle tam kapsamlı iklimlendirme çözümleri sunuyoruz
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card key={service.id} className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 group hover:-translate-y-2">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                      <p className="text-gray-600 mb-6">{service.description}</p>
                      <ul className="space-y-2">
                        {service.details.map((detail, index) => (
                          <li key={index} className="flex items-center text-sm text-gray-700">
                            <div className="w-2 h-2 bg-teal-500 rounded-full mr-3" />
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Service Process */}
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-12 mb-16">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Hizmet Sürecimiz</h2>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                1
              </div>
              <h3 className="font-bold text-gray-900 mb-2">İletişim</h3>
              <p className="text-sm text-gray-600">Bizi arayın veya form doldurun</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                2
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Ücretsiz Keşif</h3>
              <p className="text-sm text-gray-600">Uzmanımız mekanınızı inceler</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                3
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Teklif</h3>
              <p className="text-sm text-gray-600">Size özel fiyat teklifi sunuyoruz</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                4
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Uygulama</h3>
              <p className="text-sm text-gray-600">Profesyonel montaj ve devreye alma</p>
            </div>
          </div>
        </div>

        {/* Emergency Service Banner */}
        <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-12 text-center text-white">
          <Phone className="w-16 h-16 mx-auto mb-6" />
          <h2 className="text-3xl font-bold mb-4">7/24 Acil Servis Hizmeti</h2>
          <p className="text-xl text-teal-50 mb-8 max-w-2xl mx-auto">
            Klimanız arızalandı mı? Hemen bizi arayın, uzman ekibimiz yardım için hazır!
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href="tel:05516380934">
              <Button size="lg" variant="secondary" className="bg-white text-teal-600 hover:bg-gray-100 shadow-xl hover:shadow-2xl transition-all duration-300">
                Acil Arama: 0551 638 09 34
              </Button>
            </a>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-teal-600 transition-all duration-300">
                İletişim Formu
              </Button>
            </Link>
          </div>
        </div>

        {/* Service Areas */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Hizmet Alanlarımız</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <Card className="border-none shadow-md hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6 text-center">
                <h3 className="font-bold text-xl text-gray-900 mb-2">Konut</h3>
                <p className="text-gray-600 text-sm">Evler, apartmanlar, villalar</p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-md hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6 text-center">
                <h3 className="font-bold text-xl text-gray-900 mb-2">Ticari</h3>
                <p className="text-gray-600 text-sm">Ofisler, dükkanlar, mağazalar</p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-md hover:shadow-lg transition-all duration-300">
              <CardContent className="p-6 text-center">
                <h3 className="font-bold text-xl text-gray-900 mb-2">Endüstriyel</h3>
                <p className="text-gray-600 text-sm">Fabrikalar, depolar, tesisler</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;